import React, { useContext, useState } from 'react';

import { SttCircularProgress, SttSeeButton, SttHidden, SttCtrlP, SttTranslateHook } from '@stt-componentes/core';
import {
	SttTable,
	SttTableHead,
	SttTableBody,
	SttTableRow,
	SttTableCell,
	SttTableSortLabel,
	SttTablePagination,
	SttTableCard,
	SttContainerTitle
} from '@stt-componentes/core-v2';
import Form from './form';
import Detalhes from './detalhes';
import { NotificationManager } from 'react-notifications';

const ORDENACAO = {
	DIRECAO: {
		ASC: 'asc',
		DESC: 'desc'
	},
	CAMPOS: {
		DATA: 'data',
		SOLICITANTE: 'solicitante',
		PACIENTE: 'nome_paciente',
		CIDADE_PROCEDENCIA: 'nome_cidade'
	}
};

const SolicitacoesEmAberto = () => {
	const { strings } = useContext(SttTranslateHook.I18nContext);

	const [solicitacoes, setSolicitacoes] = useState([]);
	const [buscaEmAndamento, setBuscaEmAndamento] = useState(false);
	const [page, setPage] = useState(global.gConfig.pagination.start);
	const [count, setCount] = useState(global.gConfig.pagination.count);
	const [totalRegistros, setTotalRegistros] = useState(0);
	const [order, setOrder] = useState(ORDENACAO.DIRECAO.ASC);
	const [orderBy, setOrderBy] = useState(null);
	const [buscar, setBuscar] = useState(true);
	const [idSolicitacaoSelecionada, setIdSolicitacaoSelecionada] = useState(null);

	const callbackImpedirImpressao = () => {
		NotificationManager.error(strings.impressaoDesabilitada);
	};

	const resetPageOrder = () => {
		setPage(global.gConfig.pagination.start);
		setCount(global.gConfig.pagination.count);
		setOrder(ORDENACAO.DIRECAO.ASC);
		setOrderBy(null);
	};

	const handleClickSort = (campo) => {
		const isAsc = orderBy === campo && order === ORDENACAO.DIRECAO.ASC;
		const newOrder = isAsc ? ORDENACAO.DIRECAO.DESC : ORDENACAO.DIRECAO.ASC;
		setOrder(newOrder);
		setOrderBy(campo);
		setBuscar(true);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
		setBuscar(true);
	};

	const handleChangeRowsPerPage = (event) => {
		setCount(event.target.value);
		setPage(global.gConfig.pagination.start);
		setBuscar(true);
	};

	const callbackBusca = (dados) => {
		if (dados) {
			setTotalRegistros(parseInt(dados.totalRegistros));
			setSolicitacoes(dados.itens);
		} else {
			setTotalRegistros(0);
			setSolicitacoes([]);
		}
		setBuscar(false);
	};

	const handleClickVoltar = (atualizarBusca) => {
		setIdSolicitacaoSelecionada(null);
		if (atualizarBusca) {
			setBuscar(true);
		}
	};

	return (
		<>
			{!idSolicitacaoSelecionada ? (
				<>
					<SttContainerTitle titulo={strings.pesquisaSolicitacoesExame} />
					<Form
						strings={strings}
						callbackBusca={callbackBusca}
						callbackAndamento={setBuscaEmAndamento}
						page={page}
						count={count}
						orderBy={orderBy}
						order={order}
						buscar={buscar}
						resetPageOrder={resetPageOrder}
					/>

					<SttCtrlP callback={callbackImpedirImpressao} />
					<SttHidden smDown>
						<SttTable>
							<SttTableHead>
								<SttTableRow>
									<SttTableCell
										width="10%"
										sortDirection={orderBy === ORDENACAO.CAMPOS.DATA ? order : false}
									>
										<SttTableSortLabel
											active={orderBy === ORDENACAO.CAMPOS.DATA}
											direction={orderBy === ORDENACAO.CAMPOS.DATA ? order : ORDENACAO.DIRECAO.ASC}
											onClick={() => handleClickSort(ORDENACAO.CAMPOS.DATA)}
										>
											{strings.dataSolicitacao}
										</SttTableSortLabel>
									</SttTableCell>
									<SttTableCell
										width="25%"
										sortDirection={orderBy === ORDENACAO.CAMPOS.SOLICITANTE ? order : false}
									>
										<SttTableSortLabel
											active={orderBy === ORDENACAO.CAMPOS.SOLICITANTE}
											direction={orderBy === ORDENACAO.CAMPOS.SOLICITANTE ? order : ORDENACAO.DIRECAO.ASC}
											onClick={() => handleClickSort(ORDENACAO.CAMPOS.SOLICITANTE)}
										>
											{strings.solicitante}
										</SttTableSortLabel>
									</SttTableCell>
									<SttTableCell
										width="25%"
										sortDirection={orderBy === ORDENACAO.CAMPOS.PACIENTE ? order : false}
									>
										<SttTableSortLabel
											active={orderBy === ORDENACAO.CAMPOS.PACIENTE}
											direction={orderBy === ORDENACAO.CAMPOS.PACIENTE ? order : ORDENACAO.DIRECAO.ASC}
											onClick={() => handleClickSort(ORDENACAO.CAMPOS.PACIENTE)}
										>
											{strings.paciente}
										</SttTableSortLabel>
									</SttTableCell>
									<SttTableCell
										width="15%"
										sortDirection={orderBy === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA ? order : false}
									>
										<SttTableSortLabel
											active={orderBy === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA}
											direction={orderBy === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA ? order : ORDENACAO.DIRECAO.ASC}
											onClick={() => handleClickSort(ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA)}
										>
											{`${strings.municipio}/${strings.uf}`}
										</SttTableSortLabel>
									</SttTableCell>
									<SttTableCell
										width="5%"
										align="center"
									>
										{strings.visualizar}
									</SttTableCell>
								</SttTableRow>
							</SttTableHead>
							<SttTableBody>
								{buscaEmAndamento ? (
									<SttTableRow key={-1}>
										<SttTableCell
											colSpan={6}
											align="center"
										>
											<SttCircularProgress />
										</SttTableCell>
									</SttTableRow>
								) : solicitacoes.length === 0 ? (
									<SttTableRow key={-1}>
										<SttTableCell
											colSpan={6}
											align="center"
										>
											{strings.nenhumRegistroEncontrado}
										</SttTableCell>
									</SttTableRow>
								) : (
									solicitacoes.map((row, index) => (
										<SttTableRow key={index}>
											<SttTableCell>{`${row.data_formatada} ${global.gConfig.sufixo_data_hora}`}</SttTableCell>
											<SttTableCell>{row.solicitante}</SttTableCell>
											<SttTableCell>{row.nome_paciente}</SttTableCell>
											<SttTableCell>{row.nome_cidade_estado}</SttTableCell>
											<SttTableCell align="center">
												<SttSeeButton
													id={`btn-ver-solicitacao-${index}`}
													onClick={() => {
														setIdSolicitacaoSelecionada(row.id);
													}}
												/>
											</SttTableCell>
										</SttTableRow>
									))
								)}
							</SttTableBody>
						</SttTable>
					</SttHidden>
					<SttHidden mdUp>
						{buscaEmAndamento || solicitacoes.length === 0 ? (
							<SttTableCard
								carregando={buscaEmAndamento}
								nenhumRegistroEncontrado={solicitacoes.length === 0 ? strings.nenhumRegistroEncontrado : null}
							/>
						) : (
							solicitacoes.map((row, index) => (
								<SttTableCard
									key={index}
									titulo={row.nome_paciente}
									acao={<SttSeeButton onClick={() => setIdSolicitacaoSelecionada(row.id)} />}
									conteudo={[
										[
											{ titulo: strings.data, valor: `${row.data_formatada} ${global.gConfig.sufixo_data_hora}`, xs: 6 },
											{
												titulo: `${strings.municipio}/${strings.uf}`,
												valor: row.nome_cidade_estado,
												xs: 6
											}
										],
										[{ titulo: strings.solicitante, valor: row.solicitante }]
									]}
								/>
							))
						)}
					</SttHidden>
					{solicitacoes.length > 0 ? (
						<SttTablePagination
							rowsPerPageOptions={[10, 20, 40]}
							component="div"
							count={totalRegistros}
							rowsPerPage={count}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							labelRowsPerPage={strings.linhasPorPagina}
							labelDisplayedRows={(params) => `${params.from}-${params.to} ${strings.de} ${params.count}`}
						/>
					) : null}
				</>
			) : (
				<Detalhes
					strings={strings}
					id={idSolicitacaoSelecionada}
					voltar={handleClickVoltar}
				/>
			)}
		</>
	);
};

export default SolicitacoesEmAberto;
